module.exports = __webpack_public_path__ + "media/images/sec_6-6-383c304b12cb98aefabf719d1780975f.png";